module.exports = __webpack_public_path__ + "img/model_k650_small.06c4912e.png";